import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';


@Component({
  selector: 'fury-outgoing-lead-list',
  templateUrl: './outgoing-lead-list.component.html',
  styleUrls: ['./outgoing-lead-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class OutgoingLeadListComponent implements OnInit, OnDestroy {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    {name: 'Added On', property: 'addedOn', visible: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Verified Name', property: 'verifiedName', visible: true},
    {name: 'Email', property: 'emailAddress', visible: true},
    {name: 'Mobile No', property: 'mobileNumber', visible: true},
    {name: 'Address', property: 'address', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'State', property: 'state', visible: true},
    {name: 'Zip Code', property: 'zipCode', visible: true},
    {name: 'Attempts', property: 'attempts', visible: true},
    {name: 'Result Code', property: 'resultCode', visible: true},
    {name: 'Status', property: 'vanillaSoftStatus', visible: true},
    {name: 'Last Agent Name', property: 'lastAgentName', visible: true},
    {name: 'Submission', property: 'submission', visible: true},
    {name: 'Last Date', property: 'vanillaSoftTimestamps', visible: true},
    {name: 'Lead Status', property: 'leadStatus', visible: true},
    {name: '3rd Party Status', property: 'thirdPartyStatus', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue = 'Outgoing Leads';
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  tabName: string = 'all';
  dashboardDetails:any;

  leadSearchForm = new FormGroup({
    source: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    verifiedName: new FormControl(""),
    emailAddress: new FormControl(""),
    mobileNumber: new FormControl(""),
    address: new FormControl(""),
    city: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    attempts: new FormControl(""),
    resultCode: new FormControl(""),
    status: new FormControl(""),
    lastAgentName: new FormControl(""),
  });


  ngUnsubscribe = new Subject<void>();
  
  constructor(
    private apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
  ) { }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
    this.router.onSameUrlNavigation = 'reload';
      this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.tabName = res?.tabName ? res.tabName : 'all';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.getLeadRequestList();
    });
  }

  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/lead/outgoing-lead-list?page=${this.pageIndex + 1
      }${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );
  }
  getLeadRequestList() {
    const {source,firstName,lastName,verifiedName, emailAddress, mobileNumber, address, city, state,zip, attempts, resultCode, status, lastAgentName } = this.leadSearchForm.value;

    const queryParams =`?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&tabName=${this.tabName}&source=${source}&firstName=${firstName}&lastName=${lastName}&verifiedName=${verifiedName}&emailAddress=${emailAddress}&mobileNumber=${mobileNumber}&address=${address}&city=${city}&state=${state}&zip=${zip}&attempts=${attempts}&resultCode=${resultCode}&status=${status}&lastAgentName=${lastAgentName}`;

    this.apiservice
      .get(
        `admin/outgoing-lead/get-outgoing-leads${queryParams}`
      ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          this.dashboardDetails = res.body?.summary;
          if (res.body.leads.data) {
            this.itemList = res.body.leads.data;
            this.totalCount = res.body.leads.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }

  navigateDetailsPage(data:any){
    this.router.navigateByUrl('/lead/lead-details/'+ data.leadId + '?type=customerInformation');
  }
 
  changeTabName(tabName: string){
      this.tabName = tabName;
      this.router.navigateByUrl(
      `/lead/outgoing-lead-list?page=${this.pageIndex + 1
      }${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );
  };
  
  ngOnDestroy(): void {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
